import { Box, BoxProps, Tooltip } from '@mui/material'
import { FC, useCallback, useState } from 'react'

export const MolsonTypographyWithTooltip: FC<
  React.PropsWithChildren<BoxProps>
> = ({ children, ...props }) => {
  const [isOverflown, setIsOverflown] = useState(false)

  const measuredRef = useCallback((node: HTMLElement) => {
    if (node !== null) {
      setTimeout(() => {
        const { scrollWidth, clientWidth } = node

        setIsOverflown(scrollWidth > clientWidth)
      })
    }
  }, [])

  return (
    <Tooltip title={isOverflown && children}>
      <Box
        overflow="hidden"
        position="relative"
        ref={measuredRef}
        textOverflow="ellipsis"
        whiteSpace="nowrap"
        {...props}
      >
        {children}
      </Box>
    </Tooltip>
  )
}
